import { useTranslation } from 'react-i18next';
import { CardActionDownload } from '@/common/components/CardActionDownload/CardActionDownload';
import { CardActionGroup } from '@/common/components/CardActionGroup/CardActionGroup';
import { CardActionLink } from '@/common/components/CardActionLink/CardActionLink';
import { Icon } from '@/common/components/Icons/Icon';
import { ROUTES } from '@/common/constants/routes';
import { useEmployeeDetails } from '@/common/contexts/user/UserDetailsContext';

export const ProfileCompanySection = () => {
  const { t } = useTranslation();
  const { company } = useEmployeeDetails();

  const benefitPolicy = company.documents.find(
    (document) => document.slug === 'benefits-policy'
  );

  return (
    <CardActionGroup
      title={t('dashboard.profile.sections.company.title')}
      size="sm"
    >
      <CardActionLink
        href={ROUTES.COMPANY_DETAILS}
        icon={<Icon icon="building" />}
        title={t('dashboard.profile.sections.company.links.company_info.title')}
        description={t(
          'dashboard.profile.sections.company.links.company_info.description'
        )}
      />
      {benefitPolicy?.url && (
        <CardActionDownload
          icon={<Icon icon="file-lines" />}
          fileUrl={benefitPolicy.url}
          title={t(
            'dashboard.profile.sections.company.links.benefits_policy.title'
          )}
          description={t(
            'dashboard.profile.sections.company.links.benefits_policy.description'
          )}
        />
      )}
    </CardActionGroup>
  );
};
